import {useDispatch} from 'react-redux';

import AemButton from '@/components/Aem/AemButton';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import {setPendingReturnFromWebAppConnection} from '@/state/slices/globalSlice';

const DcxTopBannerDefaultContent = ({bannerData, onClick}) => {
    const dispatch = useDispatch();
    const {title, description, button} = bannerData || {};
    const {redirectToExternalLink} = useConfigExternalLink(button?.externalLink);
    const onButtonClick = () => {
        onClick?.();
        redirectToExternalLink?.();
        dispatch(setPendingReturnFromWebAppConnection(true));
    };

    return (
        <div>
            <h1 className='m-0 p-0 text-32 leading-125 text-romance'>{title}</h1>
            <p className='mt-4 font-normal text-romance'>{description}</p>
            {redirectToExternalLink && (
                <AemButton primary dark onClick={onButtonClick} className='mt-8 md:max-w-[360px]' {...button} />
            )}
        </div>
    );
};

export default DcxTopBannerDefaultContent;
